import { Modal, Input, Row, Col, Switch, notification } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  actionMember,
  modalSelector,
  detailActiveSelector,
  marriedSeleector,
} from "../../../../redux/slices/member";
import { useRouteMatch, useHistory } from "react-router-dom";
import { AlertSuccess, AlertError } from "../../../util/Alert";
import { getToken, axios, URL_API } from "../../../../utils";

const ModalResetPassword = () => {
  const match = useRouteMatch();
  const dispatch = useDispatch();
  const modal = useSelector(modalSelector);
  const [password, setPassword] = useState("");
  const history = useHistory();
  const [forChangePassword, setForChangePassword] = useState(false);
  const tap = useSelector(detailActiveSelector);
  const { SET_MODAL } = actionMember;
  const married = useSelector(marriedSeleector);
  const type =
    match.params.member_type === "member"
      ? "member"
      : tap === "member"
        ? "distributor"
        : "married" || "";
  const id = type === "married" ? married?.id : match.params.id;
  const handdleChangePassword = () => {
    if (password === "" || tap === "") {
      notification.error({
        message: "เกิดข้อผิดพลาด",
        description: "กรุณากรอกข้อมูลให้ครบถ้วน",
      });
      return;
    }
    axios({
      method: "POST",
      baseURL: URL_API,
      url: `member/reset-password/${id}`,
      headers: { Authorization: "Bearer " + getToken() },
      data: {
        password,
        forChangePassword,
        type: type,
      },
    })
      .then((res) => {
        AlertSuccess(res.data.message);
        dispatch(SET_MODAL({ visible: false, type: "reset_password" }));
        history.push(match.url);
      })
      .catch((err) => {
        AlertError({ title: "เกิดข้อผิดพลาด", text: err });
      });
  };
  const handleCancel = () => {
    dispatch(SET_MODAL({ visible: false, type: "reset_password" }));
  };
  return (
    <Modal
      okText="รีเซ็ตรหัสผ่าน"
      cancelText="ปิด"
      visible={modal?.reset_password}
      onOk={handdleChangePassword}
      onCancel={handleCancel}
      title="รีเซ็ตรหัสผ่าน"
    >
      <Row gutter={[16, 16]}>
        <Col>
          <div className="mb-2">
            <span>รหัสผ่านใหม่</span>
          </div>
          <Input
            placeholder="รหัสผ่านใหม่"
            className="w-100"
            value={password}
            onChange={(e) => {
              const newValue = e.target.value;
              const regex = /^[a-zA-Z0-9!@#$%^&*()_?."\-+~;:<>/]*$/;
              if (newValue === "" || regex.test(newValue)) {
                setPassword(newValue);
              }
            }}
          />
        </Col>
        <Col>
          <Switch onChange={(e) => setForChangePassword(e)} />{" "}
          ให้เปลี่ยนรหัสผ่านเมื่อเข้าใช้งานครั้งแรก
        </Col>
      </Row>
    </Modal>
  );
};
export default ModalResetPassword;
